import { track } from "@/lib/analytics";

const links = [
  { label: "email", href: "mailto:karim@roboticscollective.org", kind: "contact" },
  { label: "linkedin", href: "https://www.linkedin.com/in/karim-siala", kind: "contact" },
  { label: "github", href: "https://github.com/karimsiala", kind: "social" },
  { label: "x", href: "https://x.com/karimsiala_", kind: "social" },
] as const;

export function SiteLinks() {
  return (
    <div className="flex flex-wrap gap-4 mt-[22px]">
      {links.map((link) => {
        const isExternal = link.href.startsWith("http");
        return (
          <a
            key={link.label}
            href={link.href}
            onClick={() => track(link.kind === "contact" ? "contact_click" : "social_click", { channel: link.label, source: "site_links" })}
            target={isExternal ? "_blank" : undefined}
            rel={isExternal ? "noreferrer" : undefined}
            className="text-[rgba(31,29,25,0.72)] no-underline pb-[2px] border-b border-transparent transition-colors duration-150 hover:text-[#7b5b33] hover:border-[#7b5b33]"
          >
            {link.label}
          </a>
        );
      })}
    </div>
  );
}
